import { useContext } from 'react';
import { RadioButton, Input } from '../components'
import { DataContext } from '../data/DataContext';
import { catEfectuarLevatamiento, catMovitoNoServicio } from '../data/MochaData';

const Step1 = () => {

    const { ReclamosInspeccionNI, setReclamosInspeccionNI, changeHandler } = useContext(DataContext);

    const changeRadio = (propierties: string, value: boolean) => {
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, [propierties]: value });
    }

    return (
        <>
            <RadioButton
                label='¿Se va a efectuar el levantamiento del accidente?*'
                field={'registration'}
                key={'registration'}
                value={ReclamosInspeccionNI.registration}
                onChange={changeRadio}
                catalog={catEfectuarLevatamiento}
            />

            {ReclamosInspeccionNI.registration === 'N' &&
                <RadioButton
                    label='¿Por qué motivo no se efecturá el servicio?*'
                    field={'reasonNotRegistered'}
                    key={'reasonNotRegistered'}
                    value={ReclamosInspeccionNI.reasonNotRegistered}
                    onChange={changeRadio}
                    catalog={catMovitoNoServicio}
                />
            }
            {ReclamosInspeccionNI.reasonNotRegistered === '4' && ReclamosInspeccionNI.registration === 'N' &&
                <Input
                    id='anotherReason'
                    field='anotherReason'
                    type='textarea'
                    label='Indique el motivo*'
                    value={ReclamosInspeccionNI.anotherReason}
                    onChange={changeHandler}
                    placeholder='Ingresar motivo'

                />
            }
        </>
    )
}

export { Step1 }